import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { Title } from '../../components/Title';
import { getRegion } from '../../selectors/filters/getRegion';
import { getUrlById } from './utils';
import { IConfig } from '@cian/config/shared';
import { getCurrentTab } from '../../selectors/tabs';
import { ETabs } from '../../types/redux/tabs';

const TITLE_TEXT = {
  [ETabs.Realtors]: 'Каталог риелторов',
  [ETabs.Agencies]: 'Каталог агентств',
};

export const TitleContainer: React.FunctionComponent = () => {
  const { config } = useApplicationContext();
  const { id } = useSelector(getRegion, shallowEqual);
  const activeTab = useSelector(getCurrentTab);
  const deviceType = useDeviceType();

  if (deviceType === 'phone') {
    return null;
  }

  const titleText = TITLE_TEXT[activeTab];

  return <Title text={titleText} linkHref={getUrlById(id, config as IConfig)} />;
};
